import { mapKeys, find } from "lodash"
import { createSelector } from "reselect"
import { makeSelectors, computeFactorsWithMetada, computeFactorViewCategories, computeFactorViewRisk, computeFactorVaR, computeSummaryRows, computeTotalRow, computeFactorRiskScales, computeFactorExposure, computeCurrentFactors } from "helpers/factor-view"
import { getModelCategories, getModelFactors } from "selectors/modelMetadata"
import { DEFAULT_STATE } from "../model"

const [
  getRiskSummary,
  getValueAtRiskSummary,
  getRawRiskFactors,
  getRawValueAtRiskFactors,
  getRawFactorExposure,
  selectedFactorCategory,
] = makeSelectors("intradayRiskFactors", { intraday: true })

const getMappedRiskFactors = createSelector(
  [getRawRiskFactors],
  (riskFactors) => mapKeys(riskFactors, (factor) => factor.id),
)

export const getSummaryRows = createSelector(
  [getRiskSummary, getValueAtRiskSummary],
  computeSummaryRows,
)

export const getFactorExposure = createSelector(
  [getRawFactorExposure],
  computeFactorExposure,
)

export const getFactorValueAtRisk = createSelector(
  [getRawValueAtRiskFactors],
  computeFactorVaR,
)

// We remove factors that have nil values for all [risk, currencyExposure, valueAtRisk]
export const getFactorsWithMetadata = createSelector(
  [getMappedRiskFactors, getFactorExposure, getFactorValueAtRisk, getModelFactors],
  computeFactorsWithMetada,
)

const getIsComposite = () => false

export const getFactorRiskScales = createSelector(
  [getSummaryRows, getValueAtRiskSummary, getFactorsWithMetadata, getIsComposite],
  computeFactorRiskScales,
)

export const getTotalRow = createSelector(
  [getRiskSummary, getValueAtRiskSummary, getIsComposite, getFactorRiskScales],
  computeTotalRow,
)

export const getFactorCategories = createSelector(
  [getFactorsWithMetadata],
  computeFactorViewRisk,
)

// A category containing only nil factors will get removed by the filter on category.risk since the value will be nil
export const getCategories = createSelector(
  [getModelCategories, getSummaryRows, getFactorCategories],
  computeFactorViewCategories,
)

export const getSelectedFactorCategory = createSelector(
  [selectedFactorCategory, getCategories],
  (selected, categories) => selected === DEFAULT_STATE.selectedFactorCategory || find(categories, ({ id }) => id === selected) ? selected : DEFAULT_STATE.selectedFactorCategory,
)

export const getCurrentFactors = createSelector(
  [getFactorsWithMetadata, getSelectedFactorCategory],
  computeCurrentFactors,
)
